// extracted by mini-css-extract-plugin
module.exports = {"container":"OnboardingBanner_container__Nskz4","content":"OnboardingBanner_content__x8EwT","title":"OnboardingBanner_title__F4_sr","btn":"OnboardingBanner_btn__WVjf3"};